import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { aftersales } from 'types/aftersales';

import AfterSalesMessage from './AfterSalesMessage';

const RebookMessage = ({ afterSalesRules, canBeRebooked, timezone, currency, isRebookOFEActive }) => {
  if (canBeRebooked) {
    const activeRebookRule = afterSalesRules
      .filter(({ type, override, active }) => type === aftersales.REBOOK && Boolean(isRebookOFEActive ? override : active))
      .reduce((rule, currentRule) => {
        if (!rule || (rule.active && rule.price === currentRule.price && rule.validUntil < currentRule.validUntil)) {
          return currentRule;
        }

        return rule;
      }, null);

    if (activeRebookRule) {
      return (
        <>
          <AfterSalesMessage rule={activeRebookRule} timezone={timezone} currency={currency} />
        </>
      );
    }
  }

  return (
    <span>
      <FormattedMessage id="afterSalesRule.rebook.unavailable" />
    </span>
  );
};

RebookMessage.propTypes = {
  timezone: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  canBeRebooked: PropTypes.bool,
  isRebookOFEActive: PropTypes.bool,
  afterSalesRules: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      validUntil: PropTypes.string.isRequired,
      currentActive: PropTypes.bool
    })
  ).isRequired
};

export default RebookMessage;
